import { FC } from 'react';
import Link from 'next/link';

import styles from './InternalLinkGroups.module.scss';

export interface LinkGroup {
  links: Array<{
    route: string;
    text: string;
  }>;
  title: string;
}

interface Props {
  groups?: Array<LinkGroup>;
}

const InternalLinkGroups: FC<Props> = ({ groups = [] }) => (
  <div className={styles['groups']} data-test-id="internal-link-groups">
    {groups
      .filter(({ links }) => links.length > 0)
      .map(({ links, title = '' }) => (
        <div key={title} className={styles['group']} data-test-id="internal-link-group">
          <dt className={styles['title']}>{title}</dt>
          {links.map(({ route, text }) => (
            <Link key={route} prefetch={false} href={route}>
              <a className={styles['pill']} data-test-id="internal-link">
                <dd>{text}</dd>
              </a>
            </Link>
          ))}
        </div>
      ))}
  </div>
);

export default InternalLinkGroups;
